import welcomeTo from './welcomeTo/welcomeTo.js';
import readingRecs from './readingRecs/readingRecs.js';
import founderStory from './founderStory/founderStory.js';
import phaseOne from './phaseOne/phaseOne.js';
import phaseStructure from './phaseStructure.js';
import textureSensitivity from './textureSensitivity.js';
import chiaTips from './chiaTips.js'

const storyList = [welcomeTo, 
    readingRecs, 
    phaseStructure, 
    phaseOne, 
    textureSensitivity, 
    chiaTips,
founderStory]

export default storyList;